export default __webpack_public_path__ + "static/media/step2.7d0967d2.gif";